import { createComponent } from '@mtfe/sweet';
import { common } from '@mtfe/sweet-utils';
import tpl from './dom.html';
import style from './style.less';
import componentUtils from '../../../utils/index';

const { Describe } = componentUtils;
const { isFunction } = common;
const A_COUPON_MC = ''
// poiInfoG组件单张券组件ID
const SUB_COMPONENT_COUPON_ID = 'waimai_fuh30stw';
const describeCoupon = new Describe('Coupon', SUB_COMPONENT_COUPON_ID);

const ACoupon = (props) => {
    const { onCouponBtnClick, showCoupon, poiInfo } = props;

    const data = { showCoupon, poiInfo };
    const events = {
        handleCouponBtnClick: () => {
            if (isFunction(onCouponBtnClick)) {
                onCouponBtnClick(poiInfo, A_COUPON_MC);
            }
            return false;
        },
    };
    const component = createComponent(tpl, { data, style }, events);
    return component;
};
ACoupon.describe = describeCoupon;
export default ACoupon;
